import { executeCapability } from '../../utils/capabilityExecute';
import { aggregateForecast, type LocationForecastBlock } from './weatherForecastUtils';

const FALLBACK_LOCATION = 'Salt Lake City, UT';

export async function fetchLocationForecastBlocks(rawLocations: string[]): Promise<LocationForecastBlock[]> {
  const queries = rawLocations.length
    ? rawLocations.map((q) => String(q || '').trim()).filter(Boolean)
    : [FALLBACK_LOCATION];
  const results: LocationForecastBlock[] = [];

  for (const q of queries) {
    const query = q || FALLBACK_LOCATION;
    try {
      const geocode = await executeCapability<{ results?: Array<{ lat: number; lon: number; display_name?: string }> }>({
        app: 'global',
        capability: 'maps.geocodeAddress',
        input: { q: query },
      });
      const first = geocode?.results?.[0];
      if (!first) {
        results.push({
          query,
          label: query,
          tzOffsetSec: 0,
          days: [],
          error: 'Location not found',
        });
        continue;
      }
      const forecast = await executeCapability<{ data?: unknown }>({
        app: 'global',
        capability: 'weather.forecastByCoords',
        input: { lat: first.lat, lon: first.lon },
      });
      const { tzOffsetSec, days } = aggregateForecast(forecast?.data, 5);
      const label = String(first.display_name || query).trim() || query;
      results.push({
        query,
        label,
        tzOffsetSec,
        days,
        error: days.length ? undefined : 'Forecast unavailable',
      });
    } catch {
      results.push({
        query,
        label: query,
        tzOffsetSec: 0,
        days: [],
        error: 'Weather unavailable',
      });
    }
  }

  return results;
}
